export const searchParams = {
  page: {
    populate: {
      titleWithIcon: {
        populate: {
          titleIconSettings: {
            populate: {
              icon: {
                populate: {
                  uicon: {
                    populate: "*",
                  },
                  icon: {
                    populate: "*",
                  },
                },
              },
            },
          },
        },
      },
      pageIcon: {
        populate: {
          icon: {
            populate: "*",
          },
          uicon: {
            populate: "*",
          },
        },
      },
      seo: {
        populate: {
          ogImage: {
            populate: "*",
          },
        },
      },
    },
  },
  points: {
    sort: ["createdAt:desc"],
    pagination: {
      page: 1,
      pageSize: 6,
    },
    populate: {
      photos: {
        populate: "*",
      },
      equipments_types: {
        populate: "*",
      },
      workTimeList: {
        populate: "*",
      },
    },
  },
};
